<!-- Interpolation must be used in order to dynamically bind the placeholder and i18n-placeholder inputs -->
<mat-select
  #select
  class="searchableSelect"
  panelClass="virtualScroll_panel"
  placeholder="{{placeholder}}"
  i18n-placeholder="{{localizationPlaceholder}}"
  [ngClass]="{'hideArrow': shouldHideArrow}"
  [formControl]="selectControl"
  (openedChange)="onOpenedChanged($event)"
  (selectionChange)="onSelectionChanged($event)"
>
  <mat-select-trigger>
    <span
      *ngLet="(options | findByProperty : 'id' : selectControl?.value) as selectedItem"
      [class.inactiveSelection]="shouldHideInactiveOptions && selectedItem?.isActive === false"
    >
      {{selectedItem?.name}}
    </span>
  </mat-select-trigger>

  <mat-option>
    <ngx-mat-select-search [formControl]="filterControl" [placeholderLabel]="StaticMessage.SearchLabel | staticMessage">
      <mat-icon svgIcon="close" color="primary" ngxMatSelectSearchClear></mat-icon>
    </ngx-mat-select-search>
  </mat-option>

  <ng-container *ngLet="filteredOptions$ | async as filteredOptions">
    <cdk-virtual-scroll-viewport
      #virtualScroll
      minBufferPx="200"
      maxBufferPx="400"
      [style.height.px]="panelHeight"
      [itemSize]="optionSize"
    >
      <mat-option
        #option
        *cdkVirtualFor="let option of filteredOptions; trackBy: trackByFunction"
        [style.height.px]="optionSize"
        [value]="option.id"
        [attr.data-testId]="option.name"
      >
        {{option.name}}
      </mat-option>

      <!--
      This is necessary in order to keep the selected value
      https://github.com/angular/components/issues/10122
    -->
      <mat-option class="d-none" [value]="selectControl.value"></mat-option>
    </cdk-virtual-scroll-viewport>

    <mat-option *ngIf="filteredOptions.length === 0" disabled data-testId="none-option">
      {{StaticMessage.NoSearchResultsLabel | staticMessage}}
    </mat-option>
  </ng-container>
</mat-select>
